/**
 * Centralny error logger frontend → backend.
 * Wysyla bledy do /api/monitor/client-error.
 * Throttling: ten sam komunikat nie wieksza niz raz na 30s.
 */

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ENDPOINT = `${API}/monitor/client-error`;
const THROTTLE_MS = 30000;
const recentSent = new Map(); // hash -> timestamp

function shouldSend(key) {
  const now = Date.now();
  const last = recentSent.get(key);
  if (last && now - last < THROTTLE_MS) return false;
  recentSent.set(key, now);
  // czysc stare wpisy zeby Map nie rosla bez konca
  if (recentSent.size > 200) {
    const cutoff = now - THROTTLE_MS;
    for (const [k, t] of recentSent) if (t < cutoff) recentSent.delete(k);
  }
  return true;
}

export function logClientError({
  source = "frontend",
  message,
  severity = "high",
  stack_trace = "",
  additional = {},
} = {}) {
  if (!message) return;
  const key = `${source}::${message.substring(0, 100)}`;
  if (!shouldSend(key)) return;

  const payload = {
    source: String(source).substring(0, 200),
    message: String(message).substring(0, 500),
    severity,
    url: window.location.href,
    user_agent: navigator.userAgent,
    stack_trace: String(stack_trace || "").substring(0, 5000),
    additional,
  };

  // sendBeacon dziala nawet przy unload strony — fire-and-forget
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: "application/json" });
      navigator.sendBeacon(ENDPOINT, blob);
      return;
    }
  } catch (_) {
    /* fallback do fetch */
  }
  try {
    fetch(ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {
    /* nic nie robimy — logger nie moze sam wywalic strony */
  }
}

export function logUserBugReport({ title = "", description, severity = "medium", user_email = "", screenshot_data = null }) {
  const payload = {
    title: String(title).substring(0, 200),
    description: String(description).substring(0, 5000),
    severity,
    url: window.location.href,
    user_agent: navigator.userAgent,
    user_email: user_email || undefined,
    screenshot_data: screenshot_data || undefined,
  };
  return fetch(`${API}/monitor/user-report`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
